import {useState, useEffect, useRef} from "react";
import moment from "moment";

export default function useGainedFocus() {

  const THIRTY_MINUTES = 30 * 60 * 1000;

  const [isUnfocused, setIsUnfocused] = useState(false);
  const lastFocused = useRef(moment());

  useEffect(() => {
  
    const handleActivity = () => lastFocused.current = moment();
    const handleFocus = () => setIsUnfocused(moment().diff(lastFocused) > THIRTY_MINUTES);

    window.addEventListener("mousemove", handleActivity);
    window.addEventListener("keypress", handleActivity);
    window.addEventListener("click", handleActivity);
    window.addEventListener("focus", handleFocus);

    return () => {
      window.removeEventListener("mousemove", handleActivity);
      window.removeEventListener("keypress", handleActivity);
      window.removeEventListener("click", handleActivity);
      window.removeEventListener("focus", handleFocus);
    };
  }, [lastFocused]);

  return isUnfocused;
}
